import { Outlet, useNavigate } from 'react-router-dom';
import { COLORS } from '../../constants/theme';
import { useAdminAuth } from '../../hooks/useAdminAuth';

/**
 * Top-level shell for the Chancellery backoffice UI (SF-103) — dark-only (no theme toggle,
 * matching every other page in this app; there is no theming infrastructure to build a real
 * toggle on). Route guarding lives one level up in `RequireAdminAuth` (SF-112) — this component
 * renders only once that guard has already confirmed a live admin session.
 */
export function ChancelleryShell() {
  const navigate = useNavigate();
  const { username, logout } = useAdminAuth();

  const handleLogout = () => {
    logout();
    navigate('/chancellery/login', { replace: true });
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: COLORS.bg }}>
      <header
        className="flex items-center justify-between px-6 py-4"
        style={{ backgroundColor: COLORS.bgBar, borderBottom: `1px solid ${COLORS.borderBar}` }}
      >
        <div className="flex items-baseline gap-3">
          <span className="text-lg font-semibold" style={{ color: COLORS.text.primary }}>
            Chancellery
          </span>
          <span className="text-xs uppercase tracking-wide" style={{ color: COLORS.text.tertiary }}>
            World Administration
          </span>
        </div>
        <div className="flex items-center gap-3">
          <span
            className="flex items-center gap-2 px-3 py-1.5 rounded text-sm"
            style={{ backgroundColor: COLORS.card, border: `1px solid ${COLORS.border}`, color: COLORS.text.secondary }}
          >
            <span
              className="w-2 h-2 rounded-full"
              style={{ backgroundColor: COLORS.positive }}
              aria-hidden="true"
            />
            Signed in as {username}
          </span>
          <button
            type="button"
            onClick={handleLogout}
            className="px-3 py-1.5 rounded text-sm"
            style={{ backgroundColor: COLORS.cardAlt, border: `1px solid ${COLORS.border}`, color: COLORS.text.secondary }}
          >
            Log Out
          </button>
        </div>
      </header>

      <main className="max-w-[1040px] mx-auto" style={{ padding: '24px 24px 48px' }}>
        <Outlet />
      </main>
    </div>
  );
}
